module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_350.a86dfcf5.csv";